import 'css-chunksrc/client/scenes/projectExpenseEdition/form/elementAttachmentsUpload/dropZone/styles.scss';export default {};